const NAMESPACE = "navHeader";

const KEYS = {
    defaultInquiryMenuLabel: "defaultInquiryMenuLabel",
    logOutLinkLabel: "logOutLinkLabel",
    supportCenterLinkLabel: "supportCenterLinkLabel",
    notificationsLinkLabel: "notificationsLinkLabel",
    accountDropdownTooltip: "accountDropdownTooltip",
    moreDropdownTooltip: "moreDropdownTooltip",
    programsButtonLabel: "programsButtonLabel",
    cleanPowerResearchLabel: "cleanPowerResearchLabel",
    navSidebarLabel: "navSidebarLabel"
};

const MESSAGES = {
    [KEYS.defaultInquiryMenuLabel]: {
        value: "Ask a Question",
        comment: "Default label for the inquiry button."
    },
    [KEYS.logOutLinkLabel]: {
        value: "Log Out",
        comment: "Label for log out link"
    },
    [KEYS.supportCenterLinkLabel]: {
        value: "Support Center",
        comment: "Label for link that opens the support center."
    },
    [KEYS.notificationsLinkLabel]: {
        value: "Notifications",
        comment: "Label for link that opens the notifications page."
    },
    [KEYS.accountDropdownTooltip]: {
        value: "Account",
        comment: "Tooltip for dropdown that contains account-related links and buttons."
    },
    [KEYS.moreDropdownTooltip]: {
        value: "More",
        comment:
            "Tooltip for dropdown that contains header links and buttons that are compressed into a dropdown to save space."
    },
    [KEYS.programsButtonLabel]: {
        value: "Programs",
        comment: "Label for button that opens the dropdown that allows users to see and select programs."
    },
    [KEYS.cleanPowerResearchLabel]: {
        value: "Clean Power Research",
        comment: "Alt label for Clean Power Research Logo."
    },
    [KEYS.navSidebarLabel]: {
        value: "Program Navigation",
        comment: "Alt label for nav sidebar icon"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
